import { LineChart, AreaChart, BarChart3, CandlestickChart, Waves, Mountain } from 'lucide-react';

const ICONS = {
  line: LineChart,
  area: AreaChart,
  candlestick: CandlestickChart,
  bar: BarChart3,
  baseline: Waves,
  heikinAshi: Mountain,
};

// Icon segmented control -- replaces the generic react-select dropdown.
// Roving tabindex + arrow-key nav since react-select's built-in a11y is
// gone with it.
const ChartTypeSelector = ({ options, value, onChange }) => {
  const handleKeyDown = (e, index) => {
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      e.preventDefault();
      const dir = e.key === 'ArrowRight' ? 1 : -1;
      const next = options[(index + dir + options.length) % options.length];
      onChange(next.id);
    }
  };

  return (
    <div role="tablist" aria-label="Chart type" className="inline-flex items-center gap-0.5 p-0.5 rounded-lg bg-gray-100 dark:bg-white/[0.03] border border-gray-200 dark:border-white/[0.06]">
      {options.map((opt, i) => {
        const Icon = ICONS[opt.id];
        const active = opt.id === value;
        return (
          <button
            key={opt.id}
            role="tab"
            type="button"
            aria-selected={active}
            tabIndex={active ? 0 : -1}
            title={opt.label}
            onClick={() => onChange(opt.id)}
            onKeyDown={(e) => handleKeyDown(e, i)}
            className={`relative p-1.5 rounded-md transition-colors ${
              active ? 'bg-gradient-to-br from-violet-500/25 to-indigo-500/25 text-indigo-700 dark:text-indigo-300' : 'text-gray-500 hover:text-gray-800 hover:bg-gray-200 dark:text-white/40 dark:hover:text-white/70 dark:hover:bg-white/5'
            }`}
          >
            {Icon && <Icon size={15} strokeWidth={2} />}
          </button>
        );
      })}
    </div>
  );
};

export default ChartTypeSelector;
